var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"loader",style:({
    width: (_vm.width + "px"),
    minWidth: (_vm.width + "px"),
    height: (_vm.height + "px"),
    minHeight: (_vm.height + "px"),
     })})}
var staticRenderFns = []

export { render, staticRenderFns }